import { Alert, Input } from "@heroui/react";

import { Button } from "../core/Button";

export const Trust = () => {
  return (
    <>
      <Alert color="primary">DEVELOPMENT: Trust auth mode</Alert>
      <form method="GET" action="/api/callback" className="flex flex-col gap-2">
        <Input
          label="Username"
          type="text"
          placeholder="grant"
          name="username"
        />
        <Input
          label="Hostname / Instance"
          type="text"
          placeholder="toast.ooo"
          name="instance"
        />
        <Button type="submit">Login</Button>
      </form>
    </>
  );
};
